import React, { Component, Fragment } from 'react';
import ModalContainer from '../../modern/components/ModalContainer';
import Spin from './components/Spin';
import './DetailCarousel.scss';
import { SpinModal } from '@webmotors/buyer-design-system';
import { sendDispatchEvent } from '@/utils/utils';
import { config } from 'config/config';

let lazyLoadLimit = 0;

export default class DetailCarousel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			swiping: false,
			arrayLimit: 0,
			currentSlide: 0,
			swipeX: 0,
      isSpinOpen: false,
		};
		this.handleArrowKeys = this.handleArrowKeys.bind(this)
    this.handleSpinClick = this.handleSpinClick.bind(this)
    this.getCalcSpin = this.getCalcSpin.bind(this)
    this.hasSpin = this.props.spinProps && this.props.spinProps.PhotoUrl !== '' && this.props.spinProps.Url360 !== ''
    this.handleImageError = this.handleImageError.bind(this)
	}

  getCalcSpin() {
    return (this.hasSpin && !this.state.showModal) ? 1 : 0
  }

	componentWillReceiveProps(nextProps) {
		if (this.props.title !== nextProps.title) {
			this.setState({ currentSlide: 0 });
			lazyLoadLimit = 0;
		}

	}

	isGalleryOverlayOpen(state = this.state) {
		return !!state.showModal || !!state.isSpinOpen
	}

	componentDidUpdate(prevProps, prevState) {
		const wasOverlayOpen = this.isGalleryOverlayOpen(prevState)
		const isOverlayOpen = this.isGalleryOverlayOpen()
		if (wasOverlayOpen !== isOverlayOpen && typeof this.props.onGalleryOpenChange === 'function') {
			this.props.onGalleryOpenChange(isOverlayOpen)
		}
	}

	componentDidMount(){
		window.addEventListener('keydown', this.handleArrowKeys, false)
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.handleArrowKeys);
	}

  handleSpinClick(){
    if (!this.state.isSpinOpen) {
      sendDispatchEvent('abrirVisao360');
    }

    this.setState( currentState => ({ isSpinOpen: !currentState.isSpinOpen }))
  }

	handleArrowKeys(e){
		if( e.keyCode == 39 ){ this.changePhoto(1) }
		if( e.keyCode == 37 ){ this.changePhoto(0) }
		if( e.keyCode == 27 ){ this.closeModal() }
	}

	closeModal() {
		this.setState({ showModal: false, overlay: false });
	}

	handleLazyLoad(i) {
		(lazyLoadLimit < this.state.currentSlide) && (lazyLoadLimit = this.state.currentSlide)
		if (i < lazyLoadLimit + 8) {
			return true;
		}
		return false;
	}

	handleSwipe(fullSize) {
    if (fullSize) {
			return { transform: 'translate(calc(-' + this.state.currentSlide * 100 + '%))'};
		}
		return { transform: 'translate(calc(-' + Math.min( (this.props.photos.length + (this.getCalcSpin())) - 3 , this.state.currentSlide ) * 100 + '% / 3))', maxHeight: '480px' };
	}

  handleImageError(i) {
    const image = this.refs[`PhotoCarousel_${i}`]
    if (image) image.src = config.noPhoto
  }

	changePhoto(direction) {
		const { currentSlide, arrayLimit } = this.state;
		if (direction) {
			if (currentSlide >= arrayLimit + (this.getCalcSpin())) {
				this.setState({ currentSlide: 0 });
			} else {
				this.setState({ currentSlide: currentSlide + 1 });
			}
		} else if (currentSlide <= 0) {
			this.setState({ currentSlide: arrayLimit + (this.getCalcSpin())});
		} else {
			this.setState({ currentSlide: currentSlide - 1 });
		}
	}

	renderImage(i, bigImage, mediumImage, title, alt, fullSize) {

		if (i === 0 && this.props.useSchema) {
			return <img onClick={ ()=>{ this.handleCounterClick(i) }} className="DetailCarousel__container__items__photo" itemProp="image" src={fullSize ? bigImage : mediumImage} title={title} alt={alt} onError={() => { this.handleImageError(i) }} ref={`PhotoCarousel_${i}`} />;
		}
		else {
			return <img onClick={ ()=>{ this.handleCounterClick(i) }} className="DetailCarousel__container__items__photo" src={fullSize ? bigImage : mediumImage} title={title} alt={alt} onError={() => { this.handleImageError(i) }} ref={`PhotoCarousel_${i}`} />
		}
	}

	renderChild(i) {
		const className = 'DetailCarousel__child-container__child'
		const multiplier = i - this.state.currentSlide;
		let offset = -10 * multiplier;
		const margin = 40;
		let pxOffset = (-40 - margin) * multiplier;
		if (multiplier > 1) {
			offset = -10 + (-20 * (multiplier - 1));
			pxOffset += -(margin / 3.2) * (multiplier - 1);
		} else if (multiplier < -1) {
			offset = 10 + (-20 * (multiplier + 1));
			pxOffset += -(margin / 3.2) * (multiplier + 1);
		}
		const left = 'calc( ' + offset + '% + ' + pxOffset + 'px )';
		if (this.props.children && this.props.children[i]) {
			return (
				<div
					style={this.props.animateBorder && i !== this.state.currentSlide ? {
						transform: 'scale(0.8) translate(' + left + ')',
					} : undefined}
					className={className}
					key={'DetailCarousel__child-container_' + i}
				>
					{this.props.children[i]}
					{i !== this.state.currentSlide ? (<div onClick={this.changePhoto.bind(this, (i > this.state.currentSlide ? 1 : 0))} className="DetailCarousel__child-container__child__overlay" />) : ''}
				</div>
			);
		}
		return null;
	}

	static renderContainerClass(src) {
		if (src === 'children') {
			return 'DetailCarousel__child-container';
		}
		return 'DetailCarousel__container';
	}

  handleCounterClick(value) {
		this.setState({ currentSlide: value });
	}

  handleModalOpen(position) {
    this.setState({ showModal: true, currentSlide: position })
  }

	renderImgs(fullSize) {
    const content = [];
		let hasContent;
		let source;
		if (this.props.photos && this.props.photos.length > 0 && !this.state.showModal) {
			(this.state.arrayLimit != this.props.photos.length - 3) && this.setState({ arrayLimit: this.props.photos.length - 3 })
			hasContent = 'img';
			source = this.props.photos;
		} else if (this.props.children && this.props.children.length > 0) {
			(this.state.arrayLimit != this.props.children.length - 1) && this.setState({ arrayLimit: this.props.children.length - 1 })
			hasContent = 'children';
			source = this.props.children;
		} else if (this.props.photos && this.props.photos.length > 0 && this.state.showModal) {
			(this.state.arrayLimit != this.props.photos.length - 1) && this.setState({ arrayLimit: this.props.photos.length - 1 })
			hasContent = 'img';
			source = this.props.photos;
		}

		if (hasContent) {
      for (let i = 0; i < source.length; i++) {
        if (
          hasContent === 'img' &&
          source[i].urlBig &&
          source[i].urlMedium &&
          this.handleLazyLoad(i)
        ) {
          if (source.length > 1 || (source.length === 1 && this.hasSpin)) {
            content.push(
              <div
                data-testid={`carousel-item-${i + 1}`}
                onClick={this.handleModalOpen.bind(this, i)}
                key={i}
                id={'DetailCarouselContainerItems-0' + (i + 1)}
                className={`DetailCarousel__container__items ${source.length < 3 && !this.hasSpin ? 'DetailCarousel__container__upToTwo' : ''}`}
              >
                {this.renderImage(
                  i,
                  source[i].urlBig,
                  source[i].urlMedium,
                  source[i].title ? source[i].title : undefined,
                  source[i].alt ? source[i].alt : undefined,
                  fullSize
                )}
              </div>
            )
          } else {
            content.push(
              <div
                onClick={() =>
                  this.setState({ showModal: true, overlay: true })
                }
                data-testid={`carousel-item-${i + 1}`}
                key={i}
                id={'DetailCarouselContainerItems-0' + (i + 1)}
                className="DetailCarousel__container__items DetailCarousel__container__upToTwo"
              >
                {this.renderImage(
                  i,
                  source[i].urlBig,
                  source[i].urlMedium,
                  source[i].title ? source[i].title : undefined,
                  source[i].alt ? source[i].alt : undefined,
                  fullSize
                )}
              </div>
            )
          }

        } else if (hasContent === 'img' && source[i].url) {
          content.push(
            <div
              data-testid={`carousel-item-${i + 1}`}
              key={i}
              id={'DetailCarouselContainerItems-0' + (i + 1)}
              className="DetailCarousel__container__items"
            >
              <img
                className="DetailCarousel__container__items__photo"
                src={source[i].url}
                style={{maxHeight: '480px'}}
                onError={() => { this.handleImageError(i) }}
                ref={`PhotoCarousel_${i}`}
              />
            </div>
          )
        } else if (hasContent === 'children') {
          content.push(this.renderChild(i))
        }
      }

      this.hasSpin && !this.state.showModal &&
      content.unshift(
        <Spin
          key="spin-01"
          image={this.props.spinProps.PhotoUrl}
          onClick={this.handleSpinClick}
        />
      )

      return (
        <Fragment>
          <div className={DetailCarousel.renderContainerClass(hasContent)}>
            {!this.props.noNumberCounter ? (
              <div
                id="DetailCarouselAmount"
                className="DetailCarousel__container__amount-photos"
              >
                {this.state.currentSlide + 1} de {source.length}{' '}
              </div>
            ) : (
              ''
            )}
            <div
              data-testid="container-animation"
              className={this.renderAnimationClass()}
              style={this.handleSwipe(fullSize)}
            >
              {content}
            </div>
          </div>
          {this.renderArrows(source)}
        </Fragment>
      )
    }
	}

	renderAnimationClass() {
		return 'DetailCarousel__container__animation' + (this.state.swiping ? ' DetailCarousel__container__animation__swiping' : '');
	}

	renderPhotoCounter(source) {
		if (!this.props.noCounter) {
			const counter = [];
			if (source && source.length > 1) {
        const total = source.length + (this.getCalcSpin())
				for (let i = 0; i < total; i++) {
					if (source[i]) {
						let className = 'DetailCarousel__thumbnail__items'
						if (i === this.state.currentSlide) {
							className += this.mobileVersion ? ' DetailCarousel__counter__items--is-active' : ' DetailCarousel__thumbnail__items--is-active';
						}
						counter.push(
							<div data-testid={`thumbnail`} key={'photoCounter' + i} onClick={this.handleCounterClick.bind(this, i)} className={className}>
								<img alt="thumbnail" src={source[i].urlSmall} width="90" height="66" />
							</div>,
						);
					}
				}
				return <div className="DetailCarousel__counter">{counter}</div>;
			}
		}
		return null;
	}

	renderArrows(source) {
		if (source && source.length > 3 || source && source.length > 1 && this.state.showModal) {
			return (
				<div className="DetailCarousel__arrows">
					<div data-testid="carousel-left-button" className="DetailCarousel__arrows__item DetailCarousel__arrows__item--left" onClick={() => this.changePhoto(0)} ><i className="icon-left"></i></div>
					<div data-testid="carousel-right-button" className="DetailCarousel__arrows__item DetailCarousel__arrows__item--right" onClick={() => this.changePhoto(1)} ><i className="icon-right"></i></div>
				</div>
			);
		}
		return false;
	}

  renderSpinModal() {
    if (!this.props.spinProps) return null

    return <SpinModal href={this.props.spinProps.Url360} isOpen={this.state.isSpinOpen} onClose={this.handleSpinClick} />
  }

	renderModal() {
		if (this.state.showModal) {
			return (
				<ModalContainer show={this.state.showModal} onBgClick={() => this.closeModal()}>
					<div className="DetailCarousel__modal">
						<div className={'DetailCarousel__modal__close'}>
							<span className={'DetailCarousel__modal__close__modal'} onClick={this.closeModal.bind(this)}>Fechar</span>
						</div>
						{this.renderImgs(true)}
						{this.renderPhotoCounter(this.props.photos)}
					</div>
				</ModalContainer>
			);
		}
		return <span />
	}

	render() {
		return (
			<Fragment>
				<div className="DetailCarousel">
					{this.renderImgs()}
					{this.props.children}
				</div>
				{this.renderModal()}
        {this.renderSpinModal()}
			</Fragment>
		)
	}
}
